import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty, toConsumableArray as _toConsumableArray, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { clsx } from '../../node_modules/.pnpm/clsx@2.0.0/node_modules/clsx/dist/clsx.mjs.js';

var _excluded = ["maxWidth", "minWidth", "styles"];
var GUI_GLOBAL_CLASS = 'gui-font-face';
var GUI_COMP_CSS_VARIABLE_CLASS = 'gui-apply-css-variable';
var ThemeBreakpoints = {
  xs: 376,
  sm: 769,
  md: 993,
  lg: 1249,
  xl: 1921
};
function mergeClassNames(classes) {
  for (var _len = arguments.length, classNamesArray = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classNamesArray[_key - 1] = arguments[_key];
  }
  return Object.keys(classes).reduce(function (acc, className) {
    acc[className] = classNamesArray.reduce(function (finalClassName, currentClassNames) {
      return clsx(finalClassName, currentClassNames ? currentClassNames[className] : undefined);
    }, classes[className]);
    return acc;
  }, {});
}
var getBreakpointValue = function getBreakpointValue(breakpoint, themeBreakpoints) {
  var maxWidth = breakpoint.maxWidth,
    minWidth = breakpoint.minWidth;
  var property = 'maxWidth' in breakpoint ? 'max-width' : 'min-width';
  var breakpointSize = getSize({
    size: (property === 'max-width' ? maxWidth : minWidth) || 'md',
    sizes: themeBreakpoints
  });
  return breakpointSize;
};
var addH5StyleMedia = function addH5StyleMedia(breakpointStyles, _ref) {
  var maxWidth = _ref.maxWidth,
    minWidth = _ref.minWidth;
  var baseStyles = {};
  var property = !!minWidth ? 'min-width' : 'max-width';
  var breakpointSize = getSize({
    size: maxWidth || minWidth || 'md',
    sizes: ThemeBreakpoints
  });
  var breakpointValue = breakpointSize - (!!minWidth ? 0 : 1);
  var mediaQuery = "@media (".concat(property, ": ").concat(breakpointValue, "px)");
  Object.keys(breakpointStyles).forEach(function (key) {
    var _baseStyles$key;
    baseStyles[key] = _objectSpread2(_objectSpread2({}, (_baseStyles$key = baseStyles[key]) !== null && _baseStyles$key !== void 0 ? _baseStyles$key : {}), {}, _defineProperty({}, mediaQuery, _objectSpread2({}, breakpointStyles[key])));
  });
  return baseStyles;
};
var addBreakpointMedia = function addBreakpointMedia(styleGenerator, defaultValues, breakpoints, themeBreakpoints) {
  var baseStyles = styleGenerator(defaultValues);
  var sorted = _toConsumableArray(breakpoints).sort(function (a, b) {
    return getBreakpointValue(b, themeBreakpoints) - getBreakpointValue(a, themeBreakpoints);
  });
  var sortedBreakpoints = breakpoints[0] && 'minWidth' in breakpoints[0] ? sorted.reverse() : sorted;
  sortedBreakpoints === null || sortedBreakpoints === void 0 || sortedBreakpoints.forEach(function (breakpoint) {
    var maxWidth = breakpoint.maxWidth,
      minWidth = breakpoint.minWidth,
      _breakpoint$styles = breakpoint.styles,
      styles = _breakpoint$styles === void 0 ? {} : _breakpoint$styles,
      restBreakpointPayload = _objectWithoutProperties(breakpoint, _excluded);
    var property = 'maxWidth' in breakpoint ? 'max-width' : 'min-width';
    var breakpointSize = getSize({
      size: (property === 'max-width' ? maxWidth : minWidth) || 'md',
      sizes: themeBreakpoints
    });
    var breakpointValue = breakpointSize - (property === 'max-width' ? 1 : 0);
    var mediaQuery = "@media (".concat(property, ": ").concat(breakpointValue, "px)");
    var styleGeneratorParams = _objectSpread2(_objectSpread2({}, defaultValues), restBreakpointPayload);
    var breakpointStyles = isEmpty(styleGeneratorParams) ? {} : styleGenerator(styleGeneratorParams);
    Object.keys(baseStyles).forEach(function (key) {
      var _baseStyles$key2;
      baseStyles[key] = _objectSpread2(_objectSpread2({}, (_baseStyles$key2 = baseStyles[key]) !== null && _baseStyles$key2 !== void 0 ? _baseStyles$key2 : {}), {}, _defineProperty({}, mediaQuery, _objectSpread2(_objectSpread2({}, breakpointStyles[key] || {}), styles[key] || {})));
    });
  });
  return baseStyles;
};
function getSize(_ref2) {
  var size = _ref2.size,
    sizes = _ref2.sizes;
  if (size in sizes) {
    return sizes[size];
  }
  if (typeof size === 'number') {
    return size;
  }
  return Number(size.replace('rem', '').replace('px', '')) || sizes.md;
}
function objectDeepMerging() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (args.length === 2) {
    var ArrayOfKeyValueIsObject = Object.keys(args[0]).filter(function (key) {
      return isObject(args[0][key]);
    });
    if (ArrayOfKeyValueIsObject.length === 0) {
      return _objectSpread2(_objectSpread2({}, args[0]), args[1]);
    }
    return _objectSpread2(_objectSpread2(_objectSpread2({}, args[0]), args[1]), ArrayOfKeyValueIsObject.reduce(function (ac, cr) {
      if (args[1][cr]) {
        ac[cr] = objectDeepMerging(args[0][cr], args[1][cr]);
      }
      return ac;
    }, {}));
  } else return args.reduce(function (ac, cr) {
    return objectDeepMerging(ac, cr);
  }, {});
}
var toString = Object.prototype.toString;
function is(val, type) {
  return toString.call(val) === "[object ".concat(type, "]");
}
function isObject(val) {
  return val !== null && is(val, 'Object');
}
function isEmpty(val) {
  if (isArray(val) || isString(val)) {
    return val.length === 0;
  }
  if (val instanceof Map || val instanceof Set) {
    return val.size === 0;
  }
  if (isObject(val)) {
    return Object.keys(val).length === 0;
  }
  return false;
}
function isNumber(val) {
  return is(val, 'Number');
}
function isString(val) {
  return is(val, 'String');
}
function isFunction(val) {
  return typeof val === 'function';
}
function isArray(val) {
  return val && Array.isArray(val);
}

export { GUI_COMP_CSS_VARIABLE_CLASS, GUI_GLOBAL_CLASS, ThemeBreakpoints, addBreakpointMedia, addH5StyleMedia, getSize, is, isArray, isEmpty, isFunction, isNumber, isObject, isString, mergeClassNames, objectDeepMerging };
//# sourceMappingURL=index.js.map
